import React from 'react';
import StackLoader from '@bd/bdcore-navigation-stacks';
import { ConfigStore } from '@bd/bdcore-utilities';
import 'bootstrap/dist/css/bootstrap.min.css';
import configuration from './configuration';
import './styles';
import Index from './pages/IndexPage';
import Communities from './pages/Communities';
import CommunityDetail from './pages/CommunityDetail';
import CommunityDetailHomes from './pages/CommunityDetail/Homes';
import CommunityDetailPlans from './pages/CommunityDetail/Plans';
import Homes from './pages/Homes';
import Lots from './pages/Lots';
import HomeDetail from './pages/HomeDetail';
import Plans from './pages/Plans';
import PlanDetail from './pages/PlanDetail';
import Blogposts from './pages/Blogposts';
import BlogpostDetail from './pages/BlogpostDetail';
import NoRoute from './pages/NoRoute';
import PhotoGallery from './pages/PhotoGallery';
import AboutUs from './pages/AboutUs';
import BuildLand from './pages/BuildLand';
import MeetTheTeam from './pages/MeetTheTeam';
import ContactUs from './pages/ContactUs';
import Warranty from './pages/Warranty';
import ContactUsThankYou from './pages/ContactUs/ThankYou';

ConfigStore.setConfig(configuration);

function Entry() {
  return (
    <StackLoader
      stack="Local"
      components={[
        { override: 'Index', component: Index },
        { override: 'CommunityDetail', component: CommunityDetail },
        { override: 'CommunityDetailHomes', component: CommunityDetailHomes },
        { override: 'CommunityDetailPlans', component: CommunityDetailPlans },
        { override: 'CommunitiesList', component: Communities },
        { override: 'HomesList', component: Homes },
        { override: 'HomeDetail', component: HomeDetail },
        { override: 'PlansList', component: Plans },
        { override: 'PlanDetail', component: PlanDetail },
        { override: 'BlogpostList', component: Blogposts },
        { override: 'BlogpostDetail', component: BlogpostDetail },
        { override: 'NoRoute', component: NoRoute },
      ]}
      routes={[
        { name: 'photo-gallery', exact: true, path: '/photo-gallery', component: PhotoGallery },
        { name: 'photo-gallery-filtered', exact: true, path: '/photo-gallery/:gallery', component: PhotoGallery, sitemapIgnore: true },
        { name: 'about-us', exact: true, path: '/about-us', component: AboutUs },
        { name: 'build-on-your-land', exact: true, path: '/build-on-your-land', component: BuildLand },
        { name: 'meet-the-team', exact: true, path: '/meet-the-team', component: MeetTheTeam },
        { name: 'contact-us', exact: true, path: '/contact-us', component: ContactUs },
        { name: 'contact-us-thank-you', exact: true, path: '/contact-us/thank-you', component: ContactUsThankYou, sitemapIgnore: true },
        { name: 'lots', exact: true, path: '/lots', component: Lots },
        { name: 'warranty', exact: true, path: '/warranty', component: Warranty },
      ]}
    />
  );
}

export default Entry;



// WEBPACK FOOTER //
// ./src/Entry.js